import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { titleCase } from "@ts/utils";
import {
    updatePdGridFilters,
    updatePoGridFilters,
} from "@features/filtersSlice";
import { IActiveTab, ICheckedNode } from "@ts/common-types";
import { ICellRendererParams, RowNode } from "ag-grid-community";

const CheckboxCellRenderer: React.FC<ICellRendererParams> = (params) => {
    const activeTab = useSelector((state: IActiveTab) => state.activeTab.value);
    const dispatch = useDispatch();
    const productTitle = titleCase(params.value || "");
    const portfolioTitle = titleCase(
        params.node.data.portfolio_id ? params.value : "<blank>"
    );
    const poCheckedNode = useSelector(
        (state: ICheckedNode) => state.poCheckedNode.value
    );
    const pdCheckedNode = useSelector(
        (state: ICheckedNode) => state.pdCheckedNode.value
    );

    const checkedNodeHandler = (checkedNode: RowNode[]) => {
        if (checkedNode.length === 0) {
            // params.node.setSelected(false);
            switch (activeTab) {
                case "portfolios":
                    dispatch(updatePoGridFilters({}));
                    break;

                case "products":
                    dispatch(updatePdGridFilters({}));
                    break;
            }
        } else {
            checkedNode.forEach((item: RowNode) => {
                if (item.data.spend === params.node.data.spend) {
                    params.node.setSelected(true);
                }
            });
        }
    };

    useEffect(() => {
        switch (activeTab) {
            case "portfolios":
                checkedNodeHandler(poCheckedNode);
                break;
            case "products":
                checkedNodeHandler(pdCheckedNode);
                break;
        }
        // Added poCheckedNode,pdCheckedNode as dependency to cover es-lint warning
        // eslint-disable-next-line
    }, [activeTab, poCheckedNode, pdCheckedNode]);

    return <>{activeTab === "products" ? productTitle : portfolioTitle}</>;
};

export default CheckboxCellRenderer;
